import React from 'react';
import './visitor10k.scss';
import visitor10k from '../../../assets/visitante-10k.png';

const Visitor10k = () => {
    return (
        <div className="visitor-container">
            <h4>¡¡¡Felicidades!!! Eres el visitante número:</h4>
            <img src={visitor10k} width={300} alt="tyranosaur holding 10.000 sign"/>    
            <p className='visitor-text'>Canjea tu regalo en la sección de ¡Ofertas! introduciendo el código: <span>SOYEL10MIL</span></p>
         
        </div>
    );
}

export default Visitor10k;